import { Application_Constraints } from '../api/typegen';

export const getConstraintsDefaultAmountValue = (
  constraints: Application_Constraints['GET']['Response'] | null | undefined,
) =>
  constraints?.amountInterval?.initialValue ||
  constraints?.amountInterval?.defaultValue;

export const getConstraintsDefaultTermValue = (
  constraints: Application_Constraints['GET']['Response'] | undefined | null,
) =>
  constraints?.termInterval?.initialValue ||
  constraints?.termInterval?.defaultValue;
